"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

// global-error replaces the root layout, so it does not inherit the layout's
// metadata title. A static value keeps this client boundary self-contained.
const ERROR_PAGE_TITLE = "Error | Zapier";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.log("error", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <head>
        <title>{ERROR_PAGE_TITLE}</title>
      </head>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
